<template>
    <b-form-group label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" la :label-cols-lg="labelColsLg" :label-cols-sm="labelColsSm">
        <template #label>
            {{ title }}:
            <div v-if="!!hint" class="atmo-help">
                &nbsp;<i class="atmo-icon-question-mark"></i><span class="atmo-help__text">{{ hint }}</span>
            </div>
        </template>
        <div class="d-flex justify-content-between">
            <span v-if="!!document" class="fs-14 col-form-label my-auto"><a class="atmo-button-link" :href="$getAttachmentDownloadLink(document.id)" target="_blank">{{ document.name }}</a></span>
            <p v-else :class="!state ? 'text-danger' : ''" class="fs-14 col-form-label my-auto">Прикрепите документ</p>
            <span class="float-right text-nowrap ml-3 align-text-top">
                <action-button v-if="!!document" icon="trash" @click="removeFile(0, true)" :disabled="disabled" />
                <contract-file-uploader v-else :is-disabled="!!document || disabled" :is-main="true" class="d-inline-block my-auto" @set_file="addFile">Загрузить</contract-file-uploader>
                <b-button v-if="withSend" @click="$emit('send')" variant="custom-green" :disabled="disabled || !document" class="my-auto ml-2 d-inline-block">{{ sendTitle }}</b-button>
                <slot name="other" />
            </span>
        </div>
    </b-form-group>
</template>

<script>
import ContractFileUploader from '@/components/common/contract-file-uploader.vue';
import ActionButton from '@/components/common/action-button.vue';

export default {
    name: 'FormRowContractUpload',
    components: { ActionButton, ContractFileUploader },
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: Object
        },
        v: {
            type: Object
        },
        required: {
            type: Boolean,
            default: true
        },
        headerClass: {
            type: String,
            default: 'fs-32'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        labelColsLg: {
            default: 6
        },
        labelColsSm: {
            default: 4
        },
        hint: {
            type: String,
            default: ''
        },
        withSend: {
            type: Boolean,
            default: false
        },
        sendTitle: {
            type: String,
            default: 'Отправить'
        }
    },
    methods: {
        addFile(file) {
            this.document = file;
        },
        removeFile() {
            this.document = null;
        }
    },
    computed: {
        document: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        state() {
            return typeof this.v !== 'undefined' && this.v !== null ? !this.v.$invalid : null;
        }
    }
};
</script>

<style scoped>
.fixed-height {
    padding-top: 0.2rem !important;
    padding-bottom: 0.2rem !important;
}
.table {
    border-collapse: collapse;
    margin-bottom: 0;
}

.is-invalid {
    border: 1px solid red;
    border-radius: 2px;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    vertical-align: middle;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}
</style>
